// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const DEFAULT_PARAGRAPH_ALIGN = 'inherit';
export const DEFAULT_PARAGRAPH_VARIANTS = 'm';
//# sourceMappingURL=Paragraph.constants.js.map